<template>
	<el-popover placement="top" trigger="hover" :disabled="disabled">
		<div class="dialog">
			<div class="dialog-item" v-for="(item, index) in dialogList()" :key="index">
				<span class="label">{{ item.label }}</span>
				<span class="value">{{ item.value }}</span>
			</div>
		</div>

		<div slot="reference">
			<div v-if="multiRow">
				<div class="reference" v-for="(item, index) in dataList" :key="index">
					<span v-if="item.label">{{ item.label }}</span>
					<span>{{ item.value }}</span>
				</div>
			</div>
			<div class="reference" v-else>{{ multiRowCon() }}</div>
		</div>
	</el-popover>
</template>

<script>
export default {
	props: ['scope', 'tableData'],
	data() {
		return {};
	},
	computed: {
		disabled() {
			let { scope, tableData } = this;
			if (typeof tableData.disabled == 'boolean') return tableData.disabled;
			if (typeof tableData.disabled == 'function') return tableData.disabled(scope.row, tableData);
			return false;
		},
		multiRow() {
			let { tableData } = this;
			return tableData.multiRow;
		},
		dataList() {
			let { scope, tableData } = this;
			if (!tableData.dataList) return [];
			return tableData.dataList(scope.row, tableData);
		},
	},
	methods: {
		multiRowCon() {
			let { scope, tableData } = this;
			if (!scope && !tableData) return false;
			if (tableData.multiRowCon) {
				return tableData.multiRowCon(scope.row[tableData.bind], scope.row);
			} else {
				return scope.row[tableData.bind];
			}
		},
		dialogList() {
			let { scope, tableData } = this;
			if (!scope && !tableData) return false;
			if (tableData.dialogList) {
				return tableData.dialogList(scope.row[tableData.bind], scope.row);
			} else {
				return scope.row[tableData.bind];
			}
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.dialog {
  width: 100%;
  font-size: 12px;
  color: #333;
  line-height: 1.8em;
}

.reference {
  // 单行溢出
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
